import Lister from "./Lister";
export default function CirrusListingsAll() {
    return (
        <div>

            <div>
                <h1>
                    Cirrus Listings
                </h1>
            </div>

            <div>
                <Lister configName="cirrus" listingSite="cirrus_listings" default='placeholder_all' scrapesCollection="scrapes_v1" />
            </div>

        </div>
    );
}
